import React from 'react'
import RaisedButton from 'material-ui-legacy/RaisedButton'
import ActionDelete from 'material-ui-legacy/svg-icons/action/delete'
import Dialog from 'material-ui-legacy/Dialog'

import CancelButton from './CancelButton'

/*
Props:
- confirmMessage: Delete confirmation message. The confirmation dialogue is
  only shown if this is present.
- onTouchTap: callback for deletion. If confirmMessage is present, this will
  only be called if the user confirms the action.
*/
class DeleteButton extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      showConfimation: false
    }
  }

  _handleClick = () => this.setState({showConfimation: true})

  _handleCancel = () => this.setState({showConfimation: false})

  _handleConfirm = () => {
    this.setState({showConfimation: false})
    this.props.onTouchTap()
  }

  render() {
    const confirmActions = [
      <RaisedButton
        type='button'
        onTouchTap={this._handleConfirm}
        label={this.props.label || "Delete"}
        labelPosition="after"
        primary={true}
        icon={<ActionDelete/>}
        style={this.props.style || {margin: '5px'}}
      />,
      <CancelButton onTouchTap={this._handleCancel} />
    ]

    const clickAction = (
      Boolean(this.props.confirmMessage) ?
      this._handleClick :
      this.props.onTouchTap
    )

    return (
      <span>
        <RaisedButton
          type={this.props.type}
          disabled={this.props.disabled}
          style={this.props.style || {margin: '5px'}}
          onTouchTap={clickAction}
          label="Delete"
          labelPosition="after"
          primary={true}
          icon={<ActionDelete/>}
        />
        {this.props.confirmMessage &&
          <Dialog
            actions={confirmActions}
            modal={false}
            onRequestClose={this._handleCancel}
            open={Boolean(this.state.showConfimation)}
            title="Delete confirmation">
            {this.props.confirmMessage}
          </Dialog>
        }
      </span>
    )
  }
}

export default DeleteButton



// WEBPACK FOOTER //
// ./src/components/UI/DeleteButton.jsx